<template>
  <div>
    <div>
      <list-btn-sm  class="mr-1" @click="$emit('list')">목록</list-btn-sm>
      <save-btn-sm class="mr-1" @click="onSave">저장</save-btn-sm>
      <delete-btn-sm class="mr-1" @click="onDelete">삭제</delete-btn-sm>
    </div>
    <div>
      <mdb-input v-model="subject.name" label="과목명" icon="chalkboard-teacher" class="bolder" />
      <table class="mb-3 ml-5">
        <tr>
          <td class="pr-4">
            <span class="bolder">훈련 유형: </span>
            <select class="select-underline" v-model="subject.lectureType">
              <option>이론</option>
              <option>실기</option>
              <option>이론 및 실기</option>
            </select>
          </td>
        </tr>
      </table>
      <add-btn-sm @click="onNcsStructure"> NCS 능력단위 구성</add-btn-sm>
      <div v-for="(l , i) in subject.lectures" :key="i" class="w-100 mb-4">
        <ncs-lecture-edit :lecture="l"/>
      </div>
    </div>
    <modal-dlg v-if="modal" size="lg" icon="chalkboard" title="NCS 교과 구성" :show="modal"  @close="onClose">
      <div v-for="s in ncsSpecials" :key="s._id">
        <label>
          <input type="checkbox" v-model="selectNcsSpecials" :value="s"/>
          {{s.name}} / {{s.code}}
        </label>
      </div>
      <div class="text-center">
        <mdb-btn class="py-2" color="primary" @click="onApply">지정하기</mdb-btn>
        <mdb-btn class="py-2" @click="onClose">닫기</mdb-btn></div>
    </modal-dlg>
  </div>
</template>
<script>
import { } from 'mdbvue';
import NcsLectureEdit from './NcsLectureEdit.vue';
import NcsTraining from '@/models/NcsTraining';
export default {
  components: { NcsLectureEdit },
  name: 'NcsSubjectEdit',
  props: ['subject'],
  data: () => ({
    modal: false,
    ncsSpecials: [],
    selectNcsSpecials: []
  }),
  computed: {
    training () {
      return this.$route.query.training
    }
  },
  methods: {
    async onSave () {
      if (!confirm('저장할까요?')) return
      const subject = await this.subject.save()
      this.$emit('save', subject)
    },
    async onDelete (subject) {
      if (!confirm('삭제할까요?')) return
      await this.subject.delete()
      this.$emit('delete', this.subject)
    },
    onApply () {
      if (this.selectNcsSpecials.length === 0) {
        alert('선택된 능력단위가 없습니다.')
        return
      }
      this.subject.lectures = this.$clone(this.selectNcsSpecials)
      this.modal = false
    },
    onNcsStructure () {
      this.modal = true
    },
    onClose () {
      this.selectNcsSpecials = []
      this.modal = false
    }
  },
  async created () {
    const training = await this.$Training.get(this.training)
    const ncsTraining = await NcsTraining.get(training.ncsTraining._id)
    this.ncsSpecials = ncsTraining.ncsSpecials
  }
}
</script>
